import { FC, HTMLAttributes, LabelHTMLAttributes } from 'react';
import tw from 'twin.macro';
import 'styled-components/macro';

import { ReactComponent as HintErrorIcon } from 'component-lib/atoms/controls/assets/HintError.svg';

const Group: FC<HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => <div {...props}>{children}</div>;

const Label: FC<LabelHTMLAttributes<HTMLLabelElement>> = ({ children, ...props }) => (
  <label tw="text-lg text-primary leading-snug mb-1" {...props}>
    {children}
  </label>
);

const Hint: FC<HTMLAttributes<HTMLDivElement> & { error?: boolean }> = ({ error, children, ...props }) => (
  <div
    tw="text-lg mt-1 text-primary-light flex flex-row items-center gap-1 leading-snug"
    css={error && tw`text-error-dark!`}
    {...props}
  >
    {error && <HintErrorIcon tw="h-2 inline-block" />}
    <span>{children}</span>
  </div>
);

const Optional = () => <span tw="text-primary-light">(optional)</span>;

/** Component to render a form control with a label and hint. */
export const Form = { Group, Label, Hint, Optional };
